import * as Tone from "tone"
let inst = {};
inst.templates = [
    {
        synth:
        {
            portamento: 0.1,
            oscillator: {
                type: "square4"
            }, envelope: {
                attack: 0.1,
                decay: 0.1,
                sustain: 0.1,
                release: 0.1
            }
        },
        volume: -20,
        freq: -24,
        name: '1',
        color: '#F366A5'
    },
    {
        synth:
        {
            oscillator: {
                type: "square4"
            }, envelope: {
                attack: 0.01,
                decay: 0.1,
                sustain: 0.1,
                release: 0.5
            }
        },
        volume: -20,
        freq: -24,
        name: '2',
        color: '#f16400'

    },
    {
        synth:
        {
            oscillator: {
                type: "fatcustom",
                partials: [0.2, 1, 0, 0.5, 0.1],
                spread: 40,
                count: 3
            }, envelope: {
                attack: 0.001,
                decay: 1.6,
                sustain: 0,
                release: 1.6
            }
        },
        volume: -15,
        name: '3',
        color: '#F44336'

    },
    {
        synth:
        {
            portamento: 0.1,
            oscillator: {
                partials: [
                    1,
                    0,
                    2,
                    0,
                    3
                ]
            }, envelope: {
                attack: 0.001,
                decay: 1.2,
                sustain: 0,
                release: 1.2
            }
        },
        volume: -20,
        name: '4',
        color: '#078fdf'

    },
    {
        synth:
        {
            portamento: 0.1,
            oscillator: {
                type: "fatcustom",
                partials: [0.2, 1, 0, 0.5, 0.1],
                spread: 40,
                count: 3
            }, envelope: {
                attack: 0.001,
                decay: 1.6,
                sustain: 0,
                release: 1.6
            }

        },
        volume: -15,
        name: '5',
        color: '#10939D'

    }
]


let samples = [{
    'A2' : 'scale-A2.[mp3|ogg]',
    'A3' : 'scale-A3.[mp3|ogg]',
    'C3' : 'scale-C3.[mp3|ogg]',
    'C4' : 'scale-C4.[mp3|ogg]',
    'D3' : 'scale-C3.[mp3|ogg]',
    'D4' : 'scale-D4.[mp3|ogg]',
    'E3' : 'scale-E3.[mp3|ogg]',
    'E4' : 'scale-E4.[mp3|ogg]',
    'G2' : 'scale-G2.[mp3|ogg]',
    'G3' : 'scale-G3.[mp3|ogg]',
}, {
    'attack' : 0.01,
    'release' : 0.9,
    'baseUrl' : './teropa/'
}]

let delayL = new Tone.PingPongDelay("16n", 0.96)
let delayR = new Tone.PingPongDelay("16n", 0.96)
delayL.wet.value = 0.1;
delayR.wet.value = 0.1;
let filterLowL = new Tone.Filter(800, "lowpass");
let filterLowR = new Tone.Filter(800, "lowpass");

let filterHighL = new Tone.Filter(800, "highpass");
let filterHighR = new Tone.Filter(800, "highpass");

let pannerL1 = new Tone.Panner(-0.0).toMaster()
let pannerL2 = new Tone.Panner(-0.6).toMaster()
let pannerL3 = new Tone.Panner(-0.2).toMaster()
let pannerR1 = new Tone.Panner(0.8).toMaster()
let pannerR2 = new Tone.Panner(0.6).toMaster()
let pannerR3 = new Tone.Panner(0.2).toMaster()
let synthL = new Tone.Sampler(...samples)
let synthR = new Tone.Sampler(...samples)
synthL.volume.value = -30
synthR.volume.value = -30
synthL.connect(filterLowL)
synthR.connect(filterLowR)
filterLowL.connect(filterHighL)
filterLowR.connect(filterHighR)

filterHighL.connect(delayL)
filterHighR.connect(delayR)
delayL.connect(pannerL1)
delayL.connect(pannerL2)
delayL.connect(pannerL3)
delayR.connect(pannerR1)
delayR.connect(pannerR2)
delayR.connect(pannerR3)

inst.delayL = delayL
inst.delayR = delayR
inst.filterHighL = filterHighL
inst.filterHighR = filterHighR
inst.filterLowL = filterLowL
inst.filterLowR = filterLowR
inst.synthL = synthL
inst.synthR = synthR

export default inst